<template>
  <div class="d-flex flex-column g-4">
    <div class="d-flex flex-column g-4">
      <InputView type="text" v-model:value="value.url">
        <template v-slot:title>
          <i class="fas fa-link"></i>
        </template>
      </InputView>
      <ButtonView type="normal" color="primary" :disabled="!value.url || !/v=([a-zA-Z0-9_-]+)&?/.test(value.url)" class="w-100" @click="submit">
        <i class="fas fa-check-circle"></i>
      </ButtonView>
    </div>
  </div>
</template>

<script setup>
import InputView from "../../../forms/inputs/InputView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";

const props = defineProps({
  editor: Object
});

const value = ref({
  identifier: props.editor.getAttributes('videoEmbed').identifier,
});

const emit = defineEmits(["submit"]);

function submit() {
  emit("submit");
  props.editor.chain().focus().setVideoEmbed({ identifier: value.value.url.match('v=([a-zA-Z0-9_-]+)&?')[1] }).run();
}

</script>